import { bootstrapApplication } from '@angular/platform-browser';
import { AppConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { Amplify } from 'aws-amplify';
import { awsConfig } from './aws-exports';

// Configure Amplify exactly once across HMR/reloads
const g = globalThis as any;
if (!g.__AMPLIFY_CONFIGURED__) {
  Amplify.configure({ ...awsConfig });
  g.__AMPLIFY_CONFIGURED__ = true;
}

bootstrapApplication(AppComponent, AppConfig).catch((err) => console.error(err));
